// The design language's five status pills (docs/DESIGN.md): colour lives only
// here. Red is past its date, amber is time running, blue turns on a person's
// answer, green is good or money, grey is a type rather than a state.
const BASE = 'inline-flex items-center rounded-full px-[7px] py-[2px] text-[10.5px] font-medium leading-[1.5] whitespace-nowrap'

const TONES = {
  red: 'bg-[#F9E1E1] text-[#A03535]',
  amber: 'bg-[#FBEBD2] text-[#8A5A0E]',
  blue: 'bg-[#E6E9F7] text-[#3C4A99]',
  green: 'bg-[#E3F1E7] text-[#1F6B3E]',
  grey: 'bg-[#ECEBE6] text-[#4B4B48]'
}

export function pill(tone) {
  return `${BASE} ${TONES[tone] || TONES.grey}`
}
